import { FC } from 'react';
import { Tabs } from 'antd';
import { BookingConcepts } from './components/BookingConcepts';
import { MrrConcepts } from './components/MrrConcepts';

const Concepts: FC = () => {
    const items = [
        {
            key: 'booking',
            label: 'Booking Concepts',
            children: <BookingConcepts />,
        },
        {
            key: 'mrr',
            label: 'MRR Concepts',
            children: <MrrConcepts />,
        },
    ];

    return (
        <Tabs defaultActiveKey="booking" items={items} />
    );
};

export { Concepts };
